import { connect } from 'react-redux';
import React from 'react';
import { bindActionCreators } from 'redux';
import * as valid from 'utils/validate';
import { successState, apiCallFailure } from 'app/actions';
import routerActions from 'app/routerActions';
import { renderKBInput, renderKBSelect, toKBField } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { showApiError } from 'utils/feedback';
import {
KBForm,
KBImageCropperInput,
KBButton } from
'components';
import { api } from 'app/services';
import { Select } from 'antd';

var EditValueAddedServices = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.goBack = this.goBack.bind(this);this.submitData = this.submitData.bind(this);this.failureCallBack = this.failureCallBack.bind(this);this.changeServicesList = this.changeServicesList.bind(this);this.renderIconField = this.renderIconField.bind(this);this.renderDescImageField = this.renderDescImageField.bind(this);this.renderTagListField = this.renderTagListField.bind(this);}getInitialState()
  {
    return {};
  }componentDidMount()

  {
    const { editId } = this.props.location.query;

    if (editId) {
      // 获取详情数据
      const { change } = this.props;
      api.getValueAddedServiceDetail(editId).then(({ json }) => {
        change('name', json.name);
        change('category', json.category);
        change('icon', json.icon);
        change('desc_image', json.desc_image);
        change('tag_list', json.tag_list);
      });
    }
  }goBack()

  {
    this.props.routerActions.goBack();
  }submitData(

  model) {
    const {
      params: { id },
      apiCallFailureAction,
      successAction,
      routerActions } =
    this.props;
    const { editId } = this.props.location.query;
    if (!editId) {
      // 新建
      api.
      addValueAddedService({
        ...model,
        location_group_id: id }).

      then(res => {
        successAction({ message: '创建成功' });
        routerActions.push(`/admin/groups/${id}/valueAddedServices`);
      }).
      catch(error => {
        apiCallFailureAction({
          status: 'error',
          message: error.message });

      });
    } else {
      // 编辑
      api.
      editValueAddedService(editId, {
        ...model,
        location_group_id: id }).

      then(res => {
        successAction({ message: '修改成功' });
        routerActions.push(`/admin/groups/${id}/valueAddedServices`);
      }).
      catch(error => {
        apiCallFailureAction({
          status: 'error',
          message: error.message });

      });
    }
  }failureCallBack(

  err) {
    if (!err) return;
    return showApiError('上传失败', err);
  }changeServicesList(

  val) {
    this.props.change('tag_list', val);
  }renderIconField(

  { input, meta }) {
    const icon = toKBField(input, meta);
    return (
      <KBImageCropperInput
      title="Icon"
      aspect={1 / 1}
      isRequired
      className="kb-form-group kb-form-210 kb-form-alone"
      field={icon}
      accept="image/jpeg, image/png"
      imageSize={1024 * 10}
      failureCallBack={this.failureCallBack}
      isPublic>

        <div className="upload-portrait">
          <img
          src={
          icon.value ||
          'https://file-work-mgmt.capitastar.com.cn/cncaoren006/static/img_icon_pic@3x.png'}

          style={{
            width: '100px',
            height: '100px',
            display: 'inline-block',
            marginLeft: 0 }}

          alt="" />

          <button className="bordered-btn" type="button">
            上传图片
          </button>
        </div>
        <p
        className="color-nine"
        style={{
          fontSize: '12px' }}>


          图片格式为png,
          jpeg或jpg,文件大小不大于10M，尺寸要求40*40，显示在增值服务列表页面
        </p>
        {icon.error && icon.touched &&
        <p className="lr-error">{icon.error}</p>}

      </KBImageCropperInput>);

  }renderDescImageField(

  { input, meta }) {
    const desc_image = toKBField(input, meta);
    return (
      <KBImageCropperInput
      title="服务介绍长图"
      aspect={false}
      isRequired
      className="kb-form-group kb-form-210 kb-form-alone"
      field={desc_image}
      imageSize={1024 * 10}
      accept="image/jpeg, image/png"
      failureCallBack={this.failureCallBack}
      isPublic>

        <div className="upload-portrait">
          <img
          src={
          desc_image.value ||
          'https://file-work-mgmt.capitastar.com.cn/cncaoren006/static/img_icon_pic@3x.png'}

          style={{
            width: '100px',
            height: '100px',
            display: 'inline-block',
            marginLeft: 0 }}

          alt="" />

          <button className="bordered-btn" type="button">
            上传图片
          </button>
        </div>
        <p
        className="color-nine"
        style={{
          fontSize: '12px' }}>


          图片格式为png，jpeg或jpg，显示在增值服务详情页面
        </p>
        {desc_image.error && desc_image.touched &&
        <p className="lr-error">{desc_image.error}</p>}

      </KBImageCropperInput>);

  }renderTagListField(

  { input, meta }) {
    const tag_list = toKBField(input, meta);
    return (
      <div className="kb-form-group kb-form-c18 kb-form-alone kb-input">
        <label>服务项目<span className="must-fill">*</span></label>
        <Select
        mode="tags"
        showSearch
        style={{ width: '100%' }}
        onChange={this.changeServicesList}
        value={tag_list.value || []}>
        </Select>
        <p
        className="color-nine"
        style={{
          fontSize: '12px' }}>


          创建该服务下的具体服务内容（可输入多个）
        </p>
        {tag_list.error && tag_list.touched &&
        <p className="lr-error">{tag_list.error}</p>}

      </div>);

  }render()

  {
    const {
      submitting,
      handleSubmit } =
    this.props;

    return (
      <div className="kb-content-container">
        <KBForm
        type="reduxForm"
        onSubmit={handleSubmit(this.submitData)}>

          <header className="kb-form-header">
            <h2 className="header-title">创建增值服务</h2>
          </header>
          <div className="kb-form-container">
            <div className="kb-row ">
              <Field name="name" component={renderKBInput}
              className="kb-form-group kb-form-alone"
              title="服务名称"
              isRequired

              maxLength="8" />

            </div>
            <div className="kb-row">
              <Field name="category" component={renderKBSelect}
              defaultValue="-1"

              title="服务类别"
              isRequired
              arrayData={[
              { id: 'property', name: '物业服务' },
              { id: 'business', name: '商务服务' },
              { id: 'sustainable_love', name: '可持续喜爱 SustainLOVEbility' },
              { id: 'overseas_service', name: '出海服务' }]}

              className="kb-form-group kb-form-alone" />

            </div>

            <div className="kb-row kb-form-66">
              <Field name="icon" component={this.renderIconField} />
            </div>
            <div className="kb-row kb-form-66">
              <Field name="desc_image" component={this.renderDescImageField} />
            </div>
            <div className="kb-row">
            <Field name="tag_list" component={this.renderTagListField} />
            </div>
            <div className="kb-row" style={{ marginTop: '80px' }}>
              <span className="cancel-btn" onClick={this.goBack}>取消</span>
              <KBButton
              className="certain-btn"
              type="submit"
              submitting={submitting}>

                保存
              </KBButton>
            </div>
          </div>
        </KBForm>
      </div>);

  }};


function mapStateToProps(state, props) {
  return {
    initialValues: {
      tag_list: [] } };


}

function mapDispatchToProps(dispatch) {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    apiCallFailureAction: bindActionCreators(apiCallFailure, dispatch),
    successAction: bindActionCreators(successState, dispatch) };

}

const validate = values => {
  const errors = {};

  if (valid.required(values.name)) {
    errors.name = '请输入服务名称';
  }

  if (valid.required(values.category)) {
    errors.category = '请选择服务类别';
  }

  if (valid.required(values.icon)) {
    errors.icon = '请上传Icon';
  }

  if (valid.required(values.desc_image)) {
    errors.desc_image = '请上传服务介绍长图';
  }

  if (!values.tag_list || !values.tag_list.length) {
    errors.tag_list = '请输入服务项目';
  }

  return errors;
};

const formConfig = {
  form: 'EditValueAddedServices',
  validate: validate,
  touchOnBlur: false };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(EditValueAddedServices));
